import firebase from "firebase/app";
import "./firebaseConfig";
import "firebase/app";
import "firebase/auth";
import constants from "./constants";
import store from "./store";
import router from "./router";
import { dbFs } from "@/modules/database";

var config = {
  //local
  apiKey: "AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI",
  authDomain: "aamcart-ecommerce.firebaseapp.com",
  databaseURL: "https://aamcart-ecommerce.firebaseio.com"
  //live
  // apiKey: "AIzaSyAWxcs4d_r1nhrKxKf_OjYiNJWZm_TFKgU",
  // authDomain: "krishak-ecommerce.firebaseapp.com",
  // databaseURL: "https://krishak-ecommerce.firebaseio.com"
};
var secondaryApp = firebase.initializeApp(config, "Secondary");
// secondaryApp.auth().createUserWithEmailAndPassword(em, pwd).then(function(firebaseUser) {
//     console.log("User " + firebaseUser.uid + " created successfully!");
//     //I don't know if the next statement is necessary
//     secondaryApp.auth().signOut();
// });
export const register = (email, password, name) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        let user = firebase.auth().currentUser;
        user
          .updateProfile({
            displayName: name,
            photoURL: constants.profile.default_user_image
          })
          .then(() => {
            user
              .sendEmailVerification()
              .then(() => {
                resolve(user);
              })
              .catch(error => {
                // console.log(error);
                reject(error);
              });
          })
          .catch(error => {
            // console.log(error);
            reject(error);
          });
      })
      .catch(error => {
        reject(error.code);
      });
  });
};

export const login = (email, password) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(userCredential => {
        resolve(userCredential.user);
      })
      .catch(error => {
        reject(error.code);
      });
  });
};

export const getUser = () => {
  store.dispatch("clearAuth");
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      store.dispatch({
        type: "updateUser",
        user: user
      });
      if (localStorage.getItem("goBackTo")) {
        const goBackTo = localStorage.getItem("goBackTo");
        localStorage.removeItem("goBackTo");
        router.push(goBackTo);
      }
    } else {
      store.dispatch("clearAuth");
    }
  });
};

export const logout = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const resendVerification = () => {
  return new Promise((resolve, reject) => {
    let user = firebase.auth().currentUser;
    user
      .sendEmailVerification()
      .then(function() {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const sendResetLink = email => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(function() {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const updateSettings = (name, profilePicture) => {
  return new Promise((resolve, reject) => {
    let user = firebase.auth().currentUser;
    user
      .updateProfile({
        displayName: name,
        photoURL: profilePicture || constants.profile.default_user_image
      })
      .then(() => {
        resolve(user);
      })
      .catch(() => {
        reject(user);
      });
  });
};

export const vendorRegistration = (email, password, name, vendor) => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        let user = firebase.auth().currentUser;
        let userId = firebase.auth().currentUser.uid;
        user
          .updateProfile({
            displayName: name,
            photoURL: constants.profile.default_user_image
          })
          .then(() => {
            user
              .sendEmailVerification()
              .then(() => {
                addVendorIntoDb(userId, vendor).then(() => {
                  resolve(user);
                });
              })
              .catch(error => {
                reject(error);
                // resolve(user);
              });
          })
          .catch(error => {
            reject(error);
            // resolve(user);
          });
      })
      .catch(error => {
        // console.log(error);
        reject(error.code);
      });
  });
};
export const addVendorIntoDb = (uid, vendor) => {
  return new Promise((resolve, reject) => {
    dbFs
      .collection("vendor")
      .doc(uid)
      .set(vendor)
      .then(() => {
        let data = {
          address:
            vendor.shopDetails.address.firstLine +
            "," +
            vendor.shopDetails.address.city +
            "," +
            vendor.shopDetails.address.state,
          email: vendor.personalDetails.email,
          name: vendor.personalDetails.name,
          number: vendor.personalDetails.number,
          roleId: "7lp3KeP47b3S7XwG1SS7",
          status: true,
          vendorId: uid
        };
        addVendorUserIntoDb(uid, data)
          .then(() => {
            resolve("true");
          })
          .catch(error => {
            reject(error);
          });
      })
      .catch(error => {
        // console.log(error);
        reject(error.code);
      });
  });
};
export const addCustomerIntoDb = (uid, customer) => {
  return new Promise((resolve, reject) => {
    dbFs
      .collection("customer")
      .doc(uid)
      .set(customer, { merge: true })
      .then(() => {
        let user = firebase.auth().currentUser;
        user
          .updateProfile({
            displayName: customer.number
          })
          .then(() => {
            resolve();
          });
      })
      .catch(error => {
        // console.log(error);
        reject(error.code);
      });
  });
};
export const vendorUserRegistration = (email, password, vendorUser) => {
  return new Promise((resolve, reject) => {
    secondaryApp
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        let user = secondaryApp.auth().currentUser;
        let userId = secondaryApp.auth().currentUser.uid;
        user
          .updateProfile({
            displayName: vendorUser.name
          })
          .then(() => {
            sendResetLink(email);
            user
              .sendEmailVerification()
              .then(() => {
                addVendorUserIntoDb(userId, vendorUser).then(() => {
                  resolve();
                });
              })
              .catch(error => {
                reject(error);
                // console.log(error);
              });
          })
          .catch(error => {
            reject(error);
            // console.log(error);
          })
          .finally(() => {
            secondaryApp.auth().signOut();
          });
      })
      .catch(error => {
        // console.log(error);
        reject(error.code);
      });
  });
};
export const addVendorUserIntoDb = (uid, vendor) => {
  return new Promise((resolve, reject) => {
    dbFs
      .collection("user")
      .doc(uid)
      .set(vendor)
      .then(() => {
        resolve("true");
      })
      .catch(error => {
        reject(error.code);
      });
  });
};
